import type TriggerEngine from "../../TriggerEngine";
import type { EventSourceResult } from "../../TriggerEngine.interfaces";

export const wireScheduledEvents = async (
  engine: TriggerEngine,
): Promise<EventSourceResult> => {
  const timers = new Map<string, ReturnType<typeof setTimeout>>();

  const rules = await engine.getRules();
  for (const rule of rules) {
    if (rule.event !== "scheduled" || !rule.enabled) continue;
    const { date, time } = rule.eventConfig;
    if (!date || !time) continue;

    const targetTime = new Date(`${date}T${time}`).getTime();
    const delay = targetTime - Date.now();
    if (delay <= 0) continue;

    const timer = setTimeout(() => {
      engine.executeAction(rule);
      timers.delete(rule.id);
    }, delay);

    timers.set(rule.id, timer);
  }

  return {
    unsubscribers: [],
    timers,
  };
};
